import React from "react";
import "./RejectDialog.css";

const RejectDialog = ({
  open,
  reason,
  setReason,
  onReject,
  onCancel,
  title = "Are you sure you want to change status?",
  message = 'Change status to "Rejected"?',
  confirmLabel = "Confirm",
}) => {
  if (!open) return null;

  return (
    <div className="reject-modal-overlay" onClick={onCancel}>
      <div
        className="reject-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="reject-modal-header">
          <h2 className="reject-modal-title">{title}</h2>
          <button
            type="button"
            className="reject-modal-close"
            onClick={onCancel}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="reject-modal-body">
          {message ? <p className="reject-modal-message">{message}</p> : null}
          <div className="reject-modal-label">Add Note / Comments *</div>
          <textarea
            className="reject-modal-textarea"
            placeholder="Write comments"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            required
          />
        </div>

        <div className="reject-modal-footer">
          <button
            type="button"
            className="reject-modal-btn cancel"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="reject-modal-btn reject"
            onClick={() => {
              if (!reason?.trim()) return;
              onReject(reason.trim());
            }}
            disabled={!reason?.trim()}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectDialog;
